module.exports = {"dropDownPlaceholder":"不使用 Adobe ID 登录"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/zh_cn.json
// module id = 934
// module chunks = 0